function validation(contact) {
    let errors = {}

    // phone
    if (!contact.phone.trim()) {
        errors.phone = 'نباید خالی باشد'
    } else if (contact.phone.length > 11 || contact.phone.length < 11) {
        errors.phone = 'تعداد ارقام باید 11 عدد باشد'
    } else if (!contact.phone.startsWith('0')) {
        errors.phone = 'شروع با 0 مجاز است'
    } else {
        delete errors.phone
    }
    // mobile
    if (!contact.mobile.trim()) {
        errors.mobile = 'نباید خالی باشد'
    } else if (contact.mobile.length > 11 || contact.mobile.length < 11) {
        errors.mobile = 'تعداد ارقام باید 11 عدد باشد'
    } else if (!contact.mobile.startsWith('09')) {
        errors.mobile = 'شروع با 09 مجاز است'
    } else {
        delete errors.mobile
    }
    // sms
    if (!contact.sms.trim()) {
        errors.sms = 'نباید خالی باشد'
    } else if (contact.sms.length > 30 || contact.sms.length < 5) {
        errors.sms = 'تعداد ارقام ناصحیح است'
    } else {
        delete errors.sms
    }
    // email
    if (!contact.email.trim()) {
        errors.email = 'نباید خالی باشد'
    } else if (!(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/).test(contact.email)) {
        errors.email = 'فرمت ایمیل ناصحیح است'
    } else {
        delete errors.email
    }
    // instagram
    if (!contact.instagram.trim()) {
        errors.instagram = 'نباید خالی باشد'
    } else if (!contact.instagram.startsWith('https://www.instagram.com/')) {
        errors.instagram = 'باید با /https://www.instagram.com شروع شود'
    } else {
        delete errors.instagram
    }
    // linkedin
    if (!contact.linkedin.trim()) {
        errors.linkedin = 'نباید خالی باشد'
    } else if (!contact.linkedin.startsWith('https://www.linkedin.com/')) {
        errors.linkedin = 'باید با /https://www.linkedin.com شروع شود'
    } else {
        delete errors.linkedin
    }
    // counseling_telegram
    if (!contact.counseling_telegram.trim()) {
        errors.counseling_telegram = 'نباید خالی باشد'
    } else if (!contact.counseling_telegram.startsWith('https://t.me/')) {
        errors.counseling_telegram = 'باید با /https://t.me شروع شود'
    } else {
        delete errors.counseling_telegram
    }
    // technical_telegram
    if (!contact.technical_telegram.trim()) {
        errors.technical_telegram = 'نباید خالی باشد'
    } else if (!contact.technical_telegram.startsWith('https://t.me/')) {
        errors.technical_telegram = 'باید با /https://t.me شروع شود'
    } else {
        delete errors.technical_telegram
    }
    // address
    if (!contact.address.trim()) {
        errors.address = 'نباید خالی باشد'
    } else if (contact.address.length < 20) {
        errors.address = 'طول آدرس کم است'
    } else {
        delete errors.address
    }


    return errors
}
export default validation;